@if (isEnabled()) {
  <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nzPlacement="topLeft" (nzVisibleChange)="visible.set($event)">
    @if (isLoading()) {
      <i appIcon="spinner-third" [faSpin]="true"></i>
    } @else {
      <i appIcon="exchange" faStyle="thin"></i>
    }
  </a>
}

<nz-dropdown-menu #menu="nzDropdownMenu">
  <app-user-selection-menu [visible]="visible()" (isLoading)="isLoading.set($event)" />
</nz-dropdown-menu>
